import React from 'react';

import { Button, Typography } from '@mui/material';

import { ReactComponent as ChevronRightIconSmallGray } from '../../../../common/assets/icons/chevron_right_icon_small_gray.svg';
import { SelectableCode } from '../../../../common/types/Codes';

type CodeExtraInfoProps = {
  code: SelectableCode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const SelectUnitsButton: React.FC<CodeExtraInfoProps> = ({
  code,
  onClick,
}) => {
  return (
    <Button
      sx={{
        borderRadius: '40px',
        flexShrink: 0,
        borderStyle: 'none',
      }}
      onClick={onClick}
      color={'appGray'}
      variant={'text'}
      endIcon={
        <ChevronRightIconSmallGray
          style={{
            transform: 'rotate(90deg)',
            color: '#525662',
          }}
        />
      }
    >
      <Typography
        fontWeight={700}
        fontSize={15}
        color='rgba(38, 96, 113, 1)'
        style={{
          marginRight: '8px',
        }}
      >
        Units
      </Typography>

      <Typography fontSize={15} color='text.secondary'>
        {code.multiplier ?? 1}
      </Typography>
    </Button>
  );
};
